var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayrollActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payrol",
    transform: "translate(-78 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    transform: "translate(78 228)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Payroll",
    transform: "translate(78 228.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3269",
    "data-name": "Path 3269",
    d: "M8.96,19.429a1,1,0,0,1,0,1.414L7.9,21.9a.333.333,0,0,1-.471,0L2.1,16.567a.333.333,0,0,1,0-.471l1.057-1.057a1,1,0,0,1,1.414,0ZM21.533,10.8a1.6,1.6,0,0,0-1.13-.467,1.58,1.58,0,0,0-1.123.46l-2.373,2.2a2.307,2.307,0,0,1,.427,1.34A2.336,2.336,0,0,1,15,16.665H11.667a.333.333,0,1,1,0-.667H15a1.667,1.667,0,1,0,0-3.333H8.38a3.641,3.641,0,0,0-2.593,1.073l-.79.79a.506.506,0,0,1,.043.04l4.39,4.39A.514.514,0,0,1,9.47,19l.043-.043a1,1,0,0,1,.707-.293h5.41a3.673,3.673,0,0,0,2.97-1.517l3.087-4.267a1.6,1.6,0,0,0-.153-2.083ZM10,6.332h5.333a.333.333,0,1,0,0-.667H10a.333.333,0,1,0,0,.667ZM11.333,12A.333.333,0,0,1,12,12h1.333a.669.669,0,0,0-.667-.667,1.331,1.331,0,0,1-.333-2.62v-.38a.333.333,0,0,1,.667,0v.38A1.333,1.333,0,0,1,14,10a.333.333,0,0,1-.667,0,.667.667,0,1,0-.667.667A1.333,1.333,0,0,1,14,12h1a2.324,2.324,0,0,1,1.45.507l1.383-1.28v0A8.823,8.823,0,0,0,15.243,7H10.09a8.357,8.357,0,0,0-2.733,5.12A4.342,4.342,0,0,1,8.38,12Zm3.79-7a2.767,2.767,0,0,0,.543-1.667c0-1.053-.653-1.333-1-1.333a1.093,1.093,0,0,0-.687.223.5.5,0,0,1-.627,0A1.093,1.093,0,0,0,12.667,2a1.218,1.218,0,0,0-.7.217.567.567,0,0,1-.35.117.361.361,0,0,1-.273-.1A.983.983,0,0,0,10.667,2c-.347,0-1,.28-1,1.333A2.767,2.767,0,0,0,10.21,5Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayrollActive);
export default __webpack_public_path__ + "static/media/payrollActive.0aa280e18b0779aeab49429e09ef61d0.svg";
export { ForwardRef as ReactComponent };